import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import moment from 'moment';
import CardCustom from './cards';
import Barra from './barra';
import Pizza from './pizza';
import { instanceAxios } from '../../InstanceAxios';

function Financeiro() {
  const useStyles = makeStyles((theme) => ({
    cards: {
      padding: '2%',
    },
  }));

  const updateValue = async (d, t) => {
    await instanceAxios(localStorage.getItem('toobiauth'))
      .get(`/valorMensalRelatorio?data=${d}`)
      .then((res) => {
        switch (t) {
          case 'A':
            setDtAssinatura(d);
            setValorAssinatura(res.data.valorAssinatura);
            break;
          case 'S':
            setDtServico(d);
            setValorServicos(res.data.valorServico);
            break;
          case 'T':
            setDtTotal(d);
            setValorTotal(res.data.valorTotal);
            break;
          default:
            setDtAssinatura(d);
            setValorAssinatura(res.data.valorAssinatura);
            setDtServico(d);
            setValorServicos(res.data.valorServico);
            setDtTotal(d);
            setDtTotal(res.data.valorTotal);
            break;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const updateDataBarra = async (d) => {
    await instanceAxios(localStorage.getItem('toobiauth'))
      .get(`/relatoriosAnual?data=${d}`)
      .then((res) => {
        setAnoBarra(d);
        setDadosBarra(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const updatePagamentoServicos = async (d) => {
    await instanceAxios(localStorage.getItem('toobiauth'))
      .get(`/relatoriosPagamentoServico?data=${d}`)
      .then((res) => {
        setAnoPagamentoServicos(d);
        setPagamentoServicos(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const updatePagamentoAssinaturas = async (d) => {
    await instanceAxios(localStorage.getItem('toobiauth'))
      .get(`/relatoriosPagamentoAssinatura?data=${d}`)
      .then((res) => {
        setAnoPagamentoAssinaturas(d);
        setPagamentoAssinaturas(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const [valorAssinatura, setValorAssinatura] = useState(0);
  const [dtAssinatura, setDtAssinatura] = useState(moment());
  const [valorServicos, setValorServicos] = useState(0);
  const [dtServico, setDtServico] = useState(moment());
  const [valorTotal, setValorTotal] = useState(0);
  const [dtTotal, setDtTotal] = useState(moment());
  const [anoBarra, setAnoBarra] = useState(moment());
  const [dadosBarra, setDadosBarra] = useState([]);
  const [anoPagamentoServicos, setAnoPagamentoServicos] = useState(moment());
  const [pagamentoServicos, setPagamentoServicos] = useState([]);
  const [anoPagamentoAssinaturas, setAnoPagamentoAssinaturas] = useState(
    moment()
  );
  const [pagamentoAssinaturas, setPagamentoAssinaturas] = useState([]);
  const classes = useStyles();

  return (
    <>
      <Grid
        container
        direction="row"
        justify="space-evenly"
        alignItems="flex-start"
      >
        <Grid item>
          <CardCustom
            title="Serviços"
            value={valorServicos}
            updateValue={(d) => updateValue(d, 'S')}
            date={dtServico}
            type="money"
          />
        </Grid>
        <Grid item>
          <CardCustom
            title="Assinaturas"
            value={valorAssinatura}
            updateValue={(d) => updateValue(d, 'A')}
            date={dtAssinatura}
            type="money"
          />
        </Grid>
        <Grid item>
          <CardCustom
            title="Total"
            value={valorTotal}
            updateValue={(d) => updateValue(d, 'T')}
            date={dtTotal}
            type="money"
          />
        </Grid>
      </Grid>
      <Grid container className={classes.cards}>
        <Barra
          title="Assinanturas/Serviços"
          data={dadosBarra}
          updateValue={updateDataBarra}
          date={anoBarra}
          barInfo={[
            {
              datakey: 'valorAssinatura',
              name: 'Assinaturas',
              label: 'textAssinatura',
            },
            { datakey: 'valorServico', name: 'Serviços', label: 'textServico' },
          ]}
        />
      </Grid>
      <Grid container className={classes.cards}>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <Pizza
            title="Assinaturas"
            data={pagamentoAssinaturas}
            updateValue={updatePagamentoAssinaturas}
            date={anoPagamentoAssinaturas}
            dk="valor"
            nomeLegenda="PlanoAssinatura.nome"
            type="money"
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <Pizza
            title="Serviços"
            data={pagamentoServicos}
            updateValue={updatePagamentoServicos}
            date={anoPagamentoServicos}
            dk="valor"
            nomeLegenda="descricao"
            type="money"
          />
        </Grid>
      </Grid>
    </>
  );
}

export default Financeiro;
